export const convertToObject = (config) => {
  return config.reduce((acc, item) => {
    const day = item.diaSemana.toUpperCase();
    acc[day] = { 
      procedimentos: item.procedimentos,
      diaSemana: item.diaSemana,
      permiteAgendamento: item.permiteAgendamento,
      horaInicio: item.horaInicio,
      solicitante: item.solicitante,
      convenios: item.convenios || [],
    };
    return acc;
  }, {});
};

export const convertToObjectAgendamentoOnline = (config) => {
  return config.reduce((acc, item) => {
    const day = item.diaSemana.toUpperCase();
    acc[day] = { 
      permiteAgendamentoOnline: item.permiteAgendamentoOnline,
      diaSemana: item.diaSemana,
      permiteAgendamento: item.permiteAgendamento,
      horaInicio: item.horaInicio,
      convenios: item.convenios || [],
    };
    return acc;
  }, {});
};
